export default {"src":"/_next/static/media/tiktok.54aea1de.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};